import { PAYMENT_SUSPENSION_REASON } from 'components/customer-details/content/suspensions/settings'

export const SUSPENSION_FORM_MODEL = {
  startDate: new Date(),
  suspensionType: PAYMENT_SUSPENSION_REASON,
  description: '',
}
